
<div *ngIf="isLoading == true">
  Loading related services
</div>

<div *ngIf="isLoading == false">
 
  <div *ngIf="maps.length == 0">
    There are no related services or propers
  </div>

  <div *ngIf="maps.length > 0">
    
  <div style="border-bottom:1px solid gray">Related Services and/or Propers</div>

    <div class="table-responsive table tblGrid">
  
      <div *ngFor="let m of maps" class="gridRow row">
  
          <div *ngIf="m.Service != null">{{m.Service.Localized[0].Name}}</div>
          <div *ngIf="m.Proper != null">Proper: {{m.Proper.ProperNumber}} - Weekday: {{m.Proper.Weekday}}</div>
    
      </div>

    </div>
    
  </div>


</div>